import { ICase } from 'src/types/case';
import OrderEnum from '../../enumerables/order-enum';
import CaseEnum from '../../enumerables/case-enum';
import { getValFromEnum } from '../../components/redux-form/utils/dropdown-values';
import { changeToZeroMoment } from '../timeHelpers';
import { numberWithCommas } from '../format';

export const getDetailCase = (data: Partial<ICase>): AnyObject[] => {
    const typeEnum = OrderEnum ? OrderEnum.getEnum('OrderType') : {};
    const caseEnum = CaseEnum ? CaseEnum.getEnum('caseType') : {};
    const serviceTypeProviderEnum = OrderEnum ? OrderEnum.getEnum('ServiceTypeProvider') : {};
    const orderTypes: SelectObject[] = getValFromEnum(typeEnum);
    const caseTypes: SelectObject[] = getValFromEnum(caseEnum);
    let orderType: SelectObject | undefined | string = orderTypes.find((it) => it.value === data.orderType);
    let caseType: SelectObject | undefined | string = caseTypes.find((it) => it.value === data.caseType);
    orderType = orderType ? orderType.label : '';
    caseType = caseType ? caseType.label : '';

    let serviceType = data?.serviceType?.title;
    if (!serviceType) {
        serviceType = data?.serviceType?.cpt;
    }
    const serviceTypeProviders: SelectObject[] = getValFromEnum(serviceTypeProviderEnum);
    let serviceTypeProvider: SelectObject | undefined | string = serviceTypeProviders.find((it) => it.value === data.serviceTypeProvider);
    serviceTypeProvider = serviceTypeProvider ? serviceTypeProvider.label : '';

    const isNoVendorDistrict = data.caseType && +data.caseType !== 3 && +data.caseType !== 4;

    const dataRow = [];

    const AllocatedPeriod = OrderEnum ? OrderEnum.getEnum('AllocatedPeriod') : {};
    const valuesAllocatedPeriod: SelectObject[] = getValFromEnum(AllocatedPeriod);
    const allocatedPeriod = valuesAllocatedPeriod.find((it) =>
        +it.value === data.orderEntity?.allocatedPeriod ? +data.orderEntity?.allocatedPeriod : 0,
    );

    if (isNoVendorDistrict) {
        dataRow.push(
            ...[
                {
                    name: 'Student Full Name',
                    value: data.student ? `${data.student.firstName} ${data.student.lastName}` : '',
                },
                { name: 'Student', value: data.student ? `${data.student.code}` : '' },
            ],
        );
        if (data.caseType && +data.caseType !== 2) {
            dataRow.push({ name: 'DOE Case Number', value: data.caseNumber ? `${data.caseNumber}` : '' });
        }
    }
    dataRow.push(
        ...[
            {
                name: 'Case Number Validity',
                value: data.caseNumberValidityFrom
                    ? `${changeToZeroMoment(data.caseNumberValidityFrom, 'MMM D, YYYY')} / ${changeToZeroMoment(
                          data.caseNumberValidityTo,
                          'MMM D, YYYY',
                      )}`
                    : '',
            },
            { name: 'Service Type', value: serviceType },
            { name: 'Service Type Provider', value: serviceTypeProvider },
            /* {
            name: 'Service Location',
            value: data.serviceLocation ? `${data.serviceLocation.title}` : '',
        },*/
            { name: 'Case Type', value: `${caseType}` },
            { name: 'Min per Unit', value: `${data.minPerUnit}` },
        ],
    );

    if (isNoVendorDistrict) {
        if (data.caseType && +data.caseType !== 2) {
            dataRow.push({ name: 'Order Type', value: `${orderType}` });
        }
        if (data.orderType && (data.orderType == 1 || data.orderType == 6)) {
            dataRow.push({ name: 'Allocated Period', value: allocatedPeriod?.label });
            dataRow.push({ name: 'Allocated Hours', value: data.orderEntity?.allocatedHours });
            dataRow.push({ name: 'Maximum Available Hours', value: data.orderEntity?.maximumAvailableHours });
        }
        dataRow.push(
            ...[
                //{ name: 'Hours per Week', value: data.totalHoursWorked }
                //  { name: 'External Rate per Hour (for billing)', value: `${data.externalRatePerHour}` },
                //  { name: 'Opening Balance', value: `${data.openingBalance}` },
                //   { name: 'Total Fee', value: 'val2' },
                { name: 'Paid', value: '' },
                //  { name: 'Closing Balance', value: 'val2' },
                {
                    name: 'Parent Full Name',
                    value: data.student ? `${data.student.parentFirstName} ${data.student.parentLastName}` : '',
                },
                { name: 'Parent Email', value: data.student ? `${data.student.parentPrimaryEmail}` : '' },
                { name: 'Parent Phone', value: data.student ? `${data.student.parentPhone}` : '' },

                //      { name: 'Internal Rate per Unit (for payroll)', value: `${data.internalRatePerHour}` },
            ],
        );
        if (data.caseType && +data.caseType !== 2) {
            dataRow.push(
                ...[
                    {
                        name: 'Attorney Full Name',
                        value: data.student?.attorneyFullName ? `${data.student.attorneyFullName}` : '',
                    },
                    {
                        name: 'Attorney Email',
                        value: data.student?.attorneyPrimaryEmail ? `${data.student.attorneyPrimaryEmail}` : '',
                    },
                    //      { name: 'Internal Rate per Unit (for payroll)', value: `${data.internalRatePerHour}` },
                ],
            );
        }
    }
    const types = {
        1: { name: 'Allocated Period', value: data?.orderEntity ? `${data?.orderEntity.allocatedPeriod}` : '' },
        2: { name: 'Number of hours allocated', value: data.orderEntity ? `${data.orderEntity.allocatedHours}` : '' },
        3: {
            name: 'Amount of money allocated, $',
            value: data.orderEntity ? `${numberWithCommas(data.orderEntity.allocatedMoney)}` : '',
        },
        4: { name: 'Parent Email', value: data.student ? `${data.student.parentPrimaryEmail}` : '' },
        6: { name: 'Parent Phone', value: data.student ? `${data.student.parentPhone}` : '' },
    };
    // @ts-ignore
    const typeAdd = types[data.orderType];
    dataRow.push(typeAdd);
    return dataRow;
};
